import { useEffect, useState } from 'react';

const useScrollShadow = ({ contentRef, isOverflowing, deps = [] }) => {
    const [showShadow, setShowShadow] = useState(false);

    useEffect(() => {
        const el = contentRef.current;
        if (!el) return;

        let rafId;

        const update = () => {
            rafId = requestAnimationFrame(() => {
                if (!isOverflowing) {
                    setShowShadow(false);
                    return;
                }

                const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 2;

                setShowShadow(!atBottom);
            });
        };

        // Initial check after paint
        update();

        el.addEventListener('scroll', update);

        return () => {
            cancelAnimationFrame(rafId);
            el.removeEventListener('scroll', update);
        };
    }, [isOverflowing, ...deps]);

    return showShadow;
};

export default useScrollShadow;
